export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_summerparty-b72bea7a84956aea8a38ea382d7d389f.jpg";